import { useHost } from "../global/host.global"
import useRealtimeSnapshot from "./useRealtimeSnapshot"

export default function useTripsSnapshot(uuid?: string) {
  const { firebaseNode } = useHost()
  return useRealtimeSnapshot(uuid ? `${firebaseNode}/${uuid}` : firebaseNode)
}
